module.exports = __webpack_public_path__ + "static/bitcoinPillar-0cb235a4052876ec0b5957f8eb35e2c9.svg";